import React from "react";
import {
  Box,
  FormControlLabel,
  FormControl,
  Checkbox,
  Typography,
  Paper,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { withSnackbar } from "notistack";

import "./Earthquake.css";

//Obtiene la url del proxie para los casos donde se invocan servicios por http
const proxieURL = process.env.REACT_APP_PROXIE;

//Configuracion de las capas del mapa que utiliza el componente
var layers = {
  popocatepetl: {
    semaforoVolcan: {
      layerUpdate: null,
      layerUpdateTime: 24 * 60 * 60 * 1000,
    },
    tlamacas: {
      layerUpdate: null,
      layerUpdateTime: 30 * 1000,
    },
    altzomoni: {
      layerUpdate: null,
      layerUpdateTime: 30 * 1000,
    },
  },
};

//Nombre de las capas del mapa que utiliza el componente
var layerNames = {
  Popocatepetl: "popocatepetl",
};

const useStyles = (theme) => ({
  info: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
});

//Componente de Popocatepetl
class Popocatepetl extends React.Component {
  //Definición del estado inicial del componente
  constructor(props) {
    super(props);
    this.state = {
      semaforo: false,
      altzomoni: false,
      altzomoniUrlBase: "https://rmgir.proyectomesoamerica.org/MonitoreoVolcan/webcamsaltzomoni/1T.jpg",
        altzomoniUrl: "https://rmgir.proyectomesoamerica.org/MonitoreoVolcan/webcamsaltzomoni/1T.jpg",
      tlamacas: false,
      tlamacasUrlBase:"https://rmgir.proyectomesoamerica.org/MonitoreoVolcan/webcamstlamacas/1T.jpg",
      tlamacasUrl:"https://rmgir.proyectomesoamerica.org/MonitoreoVolcan/webcamstlamacas/1T.jpg",
      semaforoData: [],
    };
  }

  //Se establecen los check por defecto
  componentDidMount() {
    this.handleChangeCheck({ target: { name: "semaforo", checked: true } });
    this.handleChangeCheck({ target: { name: "tlamacas", checked: true } });
    this.handleChangeCheck({ target: { name: "altzomoni", checked: true } });
  }

  //Establece el estado del componente en caso de error en la llamada del servicio
  getDummyPointData = () => {
    this.props.enqueueSnackbar("Error al obtener los datos del servicio", {
      variant: "warning",
    });

    this.setState({
      semaforoData: [],
    });
  };

  //Abre nueva ventana con la url del sitio indicado
  openSite = (site) => {
    window.open(site, "_blank");
  };

  //Obtiene los datos del serivicio de sismos
  getPoints = async () => {
    let layer = this.props.moduleLayers.find(
      (l) => l.nombre === layerNames.Popocatepetl
    );
    var serviceUrl = `${proxieURL}${layer.url}`;

    const res = await fetch(serviceUrl, {
      method: "GET",
      timeout: 8000,
    }).catch((err) => {
      this.getDummyPointData();
    });

    if (res) {
      if (res.status === 200) {
        //let textp = await res.text();
        let data = await res.json();

        this.setState({
          semaforoData: data,
        });
      } else {
        this.getDummyPointData();
      }
    }
  };

  //Obtiene la imagen de la cámara Tlamacas
  getTlamacasUrl = () => {
    let newUrl =
      proxieURL + this.state.tlamacasUrlBase;

    fetch(newUrl)
      .then((response) => response.blob())
      .then((images) => {
        let outside = URL.createObjectURL(images);
        this.setState({ tlamacasUrl: outside });
      });
  };

  //Obtiene la imagen de la cámara Altzomoni
  getAltzomoniUrl = () => {
    let newUrl =
      proxieURL + this.state.altzomoniUrlBase;

    fetch(newUrl)
      .then((response) => response.blob())
      .then((images) => {
        let outside = URL.createObjectURL(images);
        this.setState({ altzomoniUrl: outside });
      });
  };

  //Maneja los eventos de cambio de estado del los controles checkbox
  handleChangeCheck = (e) => {
    const { name, checked } = e.target;

    this.setState({ [name]: checked }, () => {
      if (name === "semaforo") {
        if (checked) {
          this.getPoints();
          layers.popocatepetl.semaforoVolcan.layerUpdate = window.setInterval(
            function () {
              this.getPoints();
            },
            layers.popocatepetl.semaforoVolcan.layerUpdateTime
          );
        } else {
          clearTimeout(layers.popocatepetl.semaforoVolcan.layerUpdate);
        }
      }
      if (name === "tlamacas") {
        if (checked) {
          this.getTlamacasUrl();

          layers.popocatepetl.tlamacas.layerUpdate = window.setInterval(() => {
            this.getTlamacasUrl();
          }, layers.popocatepetl.tlamacas.layerUpdateTime);
        } else {
          clearTimeout(layers.popocatepetl.tlamacas.layerUpdate);
        }
      }
      if (name === "altzomoni") {
        if (checked) {
          this.getAltzomoniUrl();

          layers.popocatepetl.altzomoni.layerUpdate = window.setInterval(() => {
            this.getAltzomoniUrl();
          }, layers.popocatepetl.altzomoni.layerUpdateTime);
        } else {
          clearTimeout(layers.popocatepetl.altzomoni.layerUpdate);
        }
      }
    });
  };

  //Renderea la informacion del servicio
  renderInfo() {
    let total = this.state.semaforoData.length;

    if (total > 0) {
      let data = this.state.semaforoData[0];
      return (
        <Box mt={1} mb={4}>
          <Box p={1} mb={2} component={Paper}>
            <Box>
              <Typography variant="overline" style={{ fontWeight: "bolder" }}>
                Último boletín
              </Typography>
            </Box>
            <Box align="center" my={2}>
              <img
                alt="Semaforo"
                src={`./imgs/Popocatepetl/semaforo-${data.COLOR_SEMAFORO}.gif`}
                width="40%"
              ></img>

              <Typography
                display="block"
                variant="overline"
                color="primary"
                style={{ fontWeight: "bolder" }}
              >
                {data.COLOR_SEMAFORO} FASE: {data.FASE_SEMAFORO}
              </Typography>
              <Typography
                display="block"
                variant="caption"
                color="primary"
                style={{ fontWeight: "bold" }}
              >
                {data.FECHA_ESP}
              </Typography>
            </Box>

            <Box ml={2}>
              <Typography display="inline" variant="caption" color="primary">
                Exhalaciones:{" "}
              </Typography>
              <Typography display="inline" variant="caption">
                {data.EXHALACION}
              </Typography>
            </Box>

            <Box ml={2}>
              <Typography display="inline" variant="caption" color="primary">
                Explosiones:{" "}
              </Typography>
              <Typography display="inline" variant="caption">
                {data.EXPLOSION}
              </Typography>
            </Box>
            <Box ml={2}>
              <Typography display="inline" variant="caption" color="primary">
                Volcanotectónicos:{" "}
              </Typography>
              <Typography display="inline" variant="caption">
                {data.VT}
              </Typography>
            </Box>
            <Box ml={2}>
              <Typography display="inline" variant="caption" color="primary">
                Tremor:{" "}
              </Typography>
              <Typography display="inline" variant="caption">
                {data.TREMOR}
              </Typography>
            </Box>

            <Box align="center" p={1}>
              <a
               href="https://www.cenapred.unam.mx/reportesVolcanesMX/"
                color="primary"
                target="_blank"
                rel="noreferrer"
              >
                <Typography variant="overline">
                  Reporte Completo y Anteriores
                </Typography>
              </a>
            </Box>
          </Box>
        </Box>
      );
    } else return <Typography variant="overline">Cargando datos...</Typography>;
  }

  //Renderea la imagen Altzomoni
  renderAltzomoni() {
    return (
      <Box component={Paper} p={1} mb={2}>
        <Typography variant="overline" style={{ fontWeight: "bolder" }}>
          Cámara Altzomoni
        </Typography>
        <Box p={1}>
          <img
            style={{ width: "100%" }}
            src={this.state.altzomoniUrl}
            alt="Cámara de Altzomoni"
          ></img>
        </Box>
      </Box>
    );
  }

  //Renderea la imagen Tlamacas
  renderTlamacas() {
    return (
      <Box component={Paper} p={1} mb={2}>
        <Typography variant="overline" style={{ fontWeight: "bolder" }}>
          Cámara Tianguismanalco
        </Typography>
        <Box p={1}>
          <img
            style={{ width: "100%" }}
            src={this.state.tlamacasUrl}
            alt="Cámara de Tlamacas"
          ></img>
        </Box>
      </Box>
    );
  }

  //Renderele el componente incial
  render() {
    const { semaforo, altzomoni, tlamacas } = this.state;
    return (
      <Box style={{ width: "100%" }}>
        <Box align="center">
          <a
            href="https://www.cenapred.unam.mx/reportesVolcanesMX/"
            color="primary"
            target="_blank"
            rel="noreferrer"
          >
            <Typography variant="caption">CENAPRED</Typography>
          </a>
        </Box>
        <Box pl={1}>
          <FormControl component="fieldset" size="small" fullWidth>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={semaforo}
                  onChange={this.handleChangeCheck}
                  name="semaforo"
                  color="primary"
                />
              }
              label={
                <Typography variant="caption">Semáforo de alerta</Typography>
              }
            />
          </FormControl>
        </Box>
        <Typography color="primary" display="inline">
          Cámaras
        </Typography>
        <Box pl={1}>
          <FormControl component="fieldset" size="small" fullWidth>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={altzomoni}
                  onChange={this.handleChangeCheck}
                  name="altzomoni"
                  color="primary"
                />
              }
              label={<Typography variant="caption">Altzomoni</Typography>}
            />
          </FormControl>
          <FormControl component="fieldset" size="small" fullWidth>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={tlamacas}
                  onChange={this.handleChangeCheck}
                  name="tlamacas"
                  color="primary"
                />
              }
              label={<Typography variant="caption">Tianguismanalco</Typography>}
            />
          </FormControl>
        </Box>
        {(semaforo || this.state.semaforoData.length > 0) &&
          this.renderInfo(layerNames.Popocatepetl)}

        {altzomoni && this.renderAltzomoni()}
        {tlamacas && this.renderTlamacas()}
      </Box>
    );
  }
}

export default withStyles(useStyles)(withSnackbar(Popocatepetl));
